import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import type { BreakContribution, HoursRateContribution, OvertimeContribution, TrainingContribution } from "../../utils/models";
import { overtimeDetail } from "./overtimeText";
import { breakDetail, hoursRateScope, percentOf, SCOPE_SEPARATOR, trainingDetail } from "./scopeText";
import type { OvertimeBand } from "./wageComposition";

/**
 * DAT-906 · The words of the wage breakdown panel, bound to the current language: each rule line's scope,
 * and what an overtime band, a break or a training replacement means (`scopeText.ts`, `overtimeText.ts`).
 */
export const useCompositionText = () => {
	const { t } = useTranslation();
	return useMemo(
		() => ({
			hoursRateScope: (c: HoursRateContribution) => hoursRateScope(t, c),
			overtimeDetail: (c: OvertimeContribution, band: OvertimeBand) => overtimeDetail(t, c, band),
			breakDetail: (c: BreakContribution) => breakDetail(t, c),
			trainingDetail: (c: TrainingContribution, own: string, replacement: string) => trainingDetail(t, c, own, replacement),
			holidayPercent: percentOf,
			separator: SCOPE_SEPARATOR,
		}),
		[t],
	);
};
